import { render } from "./FormLabel.vue?vue&type=template&id=0348b112"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__